__turbopack_context__.v({
  "optionChainRangeFilter": "OptionChainFilter-module-scss-module__-rV6Ta__optionChainRangeFilter",
});
